// extracted by mini-css-extract-plugin
export default {"container":"get-in-touch_container__PG9Np","send-email-group":"get-in-touch_send-email-group__1itFG"};